import type { LoginComplianceProfile } from "./loginComplianceProfile";

export type LoginConsentSectionId =
  | "collection"
  | "usage"
  | "rights"
  | "retention"
  | "withdrawal"
  | "decline";

export type LoginConsentProfileContent = {
  modalTitleKey: string;
  bannerKey: string;
  summaryTitleKey: string;
  summaryBodyKey: string;
  dataProcessingConsentKey: string;
  sections: LoginConsentSectionId[];
};

export const LOGIN_CONSENT_PROFILE_CONTENT: Record<
  LoginComplianceProfile,
  LoginConsentProfileContent
> = {
  eu_gdpr: {
    modalTitleKey: "ui.copy.64149f60ef79",
    bannerKey: "ui.copy.3e7f8a9b0c1d",
    summaryTitleKey: "ui.copy.6c1d2e3f4a5b",
    summaryBodyKey: "ui.copy.7d2e3f4a5b6c",
    dataProcessingConsentKey: "ui.copy.8e7bc5c73abc",
    sections: [
      "collection",
      "usage",
      "rights",
      "retention",
      "withdrawal",
      "decline",
    ],
  },
  us_hipaa: {
    modalTitleKey: "ui.copy.8e3f4a5b6c7d",
    bannerKey: "ui.copy.4f8a9b0c1d2e",
    summaryTitleKey: "ui.copy.8e3f4a5b6c7d",
    summaryBodyKey: "ui.copy.9f4a5b6c7d8e",
    dataProcessingConsentKey: "ui.copy.0a5b6c7d8e9f",
    sections: ["collection", "usage", "retention", "withdrawal", "decline"],
  },
  global: {
    modalTitleKey: "ui.copy.64149f60ef79",
    bannerKey: "ui.copy.83443774aed6",
    summaryTitleKey: "ui.copy.4e6821a66955",
    summaryBodyKey: "ui.copy.c899f476e39c",
    dataProcessingConsentKey: "ui.copy.8e7bc5c73abc",
    sections: [
      "collection",
      "usage",
      "rights",
      "retention",
      "withdrawal",
      "decline",
    ],
  },
};

export function getLoginConsentProfileContent(
  profile: LoginComplianceProfile,
): LoginConsentProfileContent {
  return LOGIN_CONSENT_PROFILE_CONTENT[profile];
}

export function isConsentSectionVisible(
  profile: LoginComplianceProfile,
  section: LoginConsentSectionId,
): boolean {
  return getLoginConsentProfileContent(profile).sections.includes(section);
}
